import routes from '@/modules/process-editor/process-editor-routes';
import store from '@/modules/process-editor/process-editor-store';

export default {
    routes,
    store,
}
